const apiKey = "rhhuzbh-EPpkj8IGVxcFnKYd1x-ir_nnOg5tL1sgUC4";

export const defaultConfig = {
	tileLayer: `https://api.mapy.com/v1/maptiles/outdoor/256/{z}/{x}/{y}?apikey=${apiKey}`,
	attribution:
		'&copy; <a href="https://api.mapy.com/copyright" target="_blank" rel="noopener">Seznam.cz a.s. and others</a> | &copy; <a href="https://www.openstreetmap.org/copyright" target="_blank" rel="noopener">OpenStreetMap</a> contributors',
	initialView: [51.505, -0.09],
	initialZoom: 10,
	controls: {
		layers: true,
		zoom: true,
		draw: false,
	},
	showParentLayers: false,
	detourClasses: {
		path: "detour-path",
		marker: "detour-marker",
		popup: "detour-popup",
		hidden: "detour-hidden",
	},
	animatedLineClass: "animated-line",
};
